import React from 'react'
import useSearch from '../../../context/search/useSearch'

interface ISearchNoResultsComponent {
  dataSet: DOMStringMap
}

const SearchNoResults: React.FC<ISearchNoResultsComponent> = ({dataSet}): JSX.Element => {

  const {noResults} = dataSet
  const {
    quickSearchResultsProducts,
    quickSearchTerm,
    isSearching
  } = useSearch()

  if (!quickSearchTerm) {
    return null;
  }

  // Only show "No products found" if:
  // 1. Search has completed (isSearching is false)
  // 2. Results have loaded (quickSearchResultsProducts is not null)
  // 3. Results are confirmed empty (length is 0)
  return (
    !isSearching &&
    quickSearchResultsProducts !== null &&
    quickSearchResultsProducts.length === 0 ? (
        <p className="paragraph--lg">{noResults} {`'${quickSearchTerm}'`}</p>
      ) : null
  )
}

export default SearchNoResults